export function enumToArray(en): string[] {
  const types = [];
  for (const type in en) {
    if (typeof en[ type ] === 'number') {
      types.push(type);
    }
  }
  return types;
}

export function enumToKeyValueArray(en): string[] {
  const types = [];
  for (const type of Object.keys(en)) {
    types.push({
      key:   en[type],
      value: type
    });
  }
  return types;
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/core/utils.ts